import "./splitButton.scss";

import { List } from "immutable";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import FocusedPopover from "../../components/popover/FocusedPopover";
import { withScreenContext } from "../../components/screen/ScreenContext";
import keyConstants from "../../constants/keyConstants";
import Icon from "../interface/Icon";
import onPulseAnimationEnd from "../onPulseAnimationEnd";
import { asPortalChild } from "../portal/asPortalChild";
import SplitButtonOptionGroup from "./SplitButtonOptionGroup";

class SplitButton extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      popoverOpen: false,
      searchText: ""
    };
    this.onClick = this.onClick.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.renderPopover = this.renderPopover.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onClick(e) {
    const { onClick } = this.props;
    if (onClick) {
      this.setState(
        {
          popoverOpen: false
        },
        () => {
          onClick();
        }
      );
    } else {
      this.togglePopover();
    }

    if (e) {
      e.stopPropagation();
    }
  }

  togglePopover(e) {
    this.setState(
      {
        popoverOpen: !this.state.popoverOpen
      },
      () => {
        if (this.props.togglePopoverCallback) {
          this.props.togglePopoverCallback(this.state.popoverOpen);
        }
      }
    );

    if (e) {
      e.stopPropagation();
    }
  }

  renderPopover() {
    let placement = "bottom";
    let hideArrow = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `relationshipPopover ${this.props.popoverClassName || ""}`,
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target: this.props.id,
      toggle: this.togglePopover
    };

    const body = (
      <PopoverBody onClick={e => e.stopPropagation()}>
        <div className="splitBtnPopover">
          {this.props.optionGroups && this.props.optionGroups.size
            ? this.props.optionGroups.map(optionGroup => {
              return (
                <SplitButtonOptionGroup
                  key={optionGroup.id}
                  togglePopover={this.togglePopover}
                  autoFocus={!this.props.screenContext}
                  {...optionGroup}
                  onDeleteOption={this.props.onDeleteOption}
                />
              );
            })
            : null}
        </div>
      </PopoverBody>
    );

    //#!if mobile === true
// if (this.props.useMobilePortal) {
// const child = (
// <div className={popoverOptions.className}>
// <NavigationToolbar
// title={this.props.label}
// showBack={true}
// showBackArrow={true}
// onBackClick={this.togglePopover}
// backText={this.props.backText ? this.props.backText : "Back"}
// flexLeft={1}
// flexCenter={3}
// flexRight={1}
// />
// {body}
// </div>
// );
// return asPortalChild(child);
// }
    //#!endif

    return (
      <FocusedPopover
        className={popoverOptions.className}
        placement={popoverOptions.placement}
        isOpen={popoverOptions.isOpen}
        hideArrow={popoverOptions.hideArrow}
        target={popoverOptions.target}
        toggle={popoverOptions.toggle}
        trigger="legacy"
      >
        {body}
      </FocusedPopover>
    );
  }

  onKeyDown(e) {
    if (!this.props.disabled && e.key === keyConstants.Enter) {
      e.stopPropagation();
      e.preventDefault();
      this.props.optionGroups.size || this.props.clickTogglesMenu ? this.togglePopover(e) : this.onClick(e);
    }
  }

  render() {
    const props = this.props;

    const classes = [
      props.className || "",
      "splitBtn",
      props.disabled ? "disabled" : "",
      props.linkStyle ? "linkStyle" : "",
      props.orientationStyle ? props.orientationStyle : "",
      props.small ? "small" : "",
      props.showDownArrow && (props.optionGroups.size || props.clickTogglesMenu) ? "hasOptions" : "",
      props.clickTogglesMenu ? "alwaysDropdown" : "",
      props.pulse ? "pulse" : ""
    ].join(" ");

    const icon = props.icon ? (
      <Icon
        className={props.iconPosition === "right" ? "iconRight" : "iconLeft"}
        icon={props.icon}
        color={props.iconColor}
      />
    ) : null;

    return (
      <div
        className={classes}
        id={props.id && !props.clickTogglesMenu ? props.id : null}
        tabIndex={props.disabled ? null : 0}
        onKeyDown={this.onKeyDown}
        onAnimationEnd={onPulseAnimationEnd}
      >
        <div
          className="label"
          onClick={props.disabled ? null : props.clickTogglesMenu ? this.togglePopover : this.onClick}
          ref={this.props.innerRef}
        >
          {props.iconPosition === "left" ? icon : null}
          <span>{props.label}</span>
          {props.iconPosition === "right" ? icon : null}
        </div>
        {props.showDownArrow && (props.optionGroups.size || props.clickTogglesMenu) ? (
          <div
            className={`toggle ${!props.optionGroups.size && !props.clickTogglesMenu ? "disabled" : ""}`}
            id={props.id && props.clickTogglesMenu ? props.id : null}
            onClick={props.optionGroups.size || props.clickTogglesMenu ? this.togglePopover : null}
          >
            <Icon className="downArrow" icon="downArrow" color="mono" />
          </div>
        ) : null}
        {this.state.popoverOpen ? <div className="splitButtonPopoverBackdrop" onClick={this.togglePopover} /> : null}
        {this.state.popoverOpen ? this.renderPopover() : null}
      </div>
    );
  }
}

SplitButton.propTypes = {
  className: PropTypes.string,
  popoverClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  linkStyle: PropTypes.bool,
  orientationStyle: PropTypes.oneOf(["horizontal", "vertical"]),
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  onClick: PropTypes.func,
  onDeleteOption: PropTypes.func,
  id: PropTypes.string,
  optionGroups: ImmutablePropTypes.list,
  small: PropTypes.bool,
  clickTogglesMenu: PropTypes.bool,
  showDownArrow: PropTypes.bool,
  dropdownActionLabel: PropTypes.string,
  backText: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  useMobilePortal: PropTypes.bool,
  togglePopoverCallback: PropTypes.func,
  pulse: PropTypes.bool,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

SplitButton.defaultProps = {
  iconPosition: "left",
  iconColor: "iconMono",
  optionGroups: List(),
  showDownArrow: true
};

let exportedView = React.forwardRef((props, ref) => <SplitButton innerRef={ref} {...props} />);
//#!if iOS === true
// exportedView = withScreenContext(exportedView);
//#!endif
export default exportedView;
